import { createStoreContext } from "reusable/mobx-store-utils/storeUtils"

interface ProgressDotsStoreProps {
   totalSteps: number
   index: number
}

export default class ProgressDotsStore {
   sp

   constructor(sp: ProgressDotsStoreProps) {
      this.sp = sp
   }

   get totalSteps() {
      return Array.from({ length: this.sp.totalSteps }, (_, index) => index + 1)
   }

}

export const { Provider: ProgressDotsStoreProvider, useProvidedStore: useProgressDotsStore } = createStoreContext(ProgressDotsStore)
